<form [formGroup]="firstFormGroup">

    <div class="row" *ngIf="!modificando">
        <div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 contbuscar" style="margin-left: 5%">
            <p>Ingrese su rut</p>
            <!-- <div>
                <table width="140px;" >
                    <tr>
                        <td width="100px;">
                                <input placeholder="RUT" formControlName="rut" required>
                        </td>
                        <td width="10px;">
                            -
                        </td>
                        <td width="30px;">
                                <input placeholder="" formControlName="dv" required style="">
                            
                        </td>
                    </tr>
                </table>
            </div> -->
            <div class="row">
                <div class="col-lg-2 col-sm-2 col-xs-2 col-md-2">
                    <input class="form-control" placeholder="RUT sin puntos" formControlName="rut" readonly>
                    <div *ngIf="!btnBuscaRut && entrevalidar">
                        <p style="color: red; font-size: 16px;">Rut no válido</p>
                    </div>
                </div>
                <div class="col-lg-1 col-sm-1 col-xs-1 col-md-1">
                    <input class="form-control" placeholder="" formControlName="dv" readonly style="width: 60%;"
                        (keyup)="validaRut()" (blur)="validaRut()">
                </div>
                <div class="col-lg-2 col-sm-2 col-xs-2 col-md-2">
                    <button mat-raised-button color="primary" [disabled]="!btnBuscaRut" (click)="buscar_info_sol()"
                        style="margin-top: 0px;">Continuar</button>
                </div>
            </div>
            <!-- !firstFormGroup.controls.rut.valid && !firstFormGroup.controls.dv.valid -->


        </div>

    </div>
    <div class="container_info_rut" *ngIf="rut_encontrado&&!modificando">
        <div class="row">
            <p class="title_datos"><strong>Datos solicitante</strong></p>
        </div>
        <div class="container_info_rut2">
            <div class="row" style="padding-bottom: 20px">
                <div class="col-lg-2 col-md-2 col-sm-2 name_info">
                    <p>RUT:</p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                    {{ info_rut.rut }}
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info">
                    <p>Teléfono:</p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                    {{ info_rut.telefono }}
                </div>
                <hr class="col-lg-10 col-md-10 col-sm-10" />
            </div>
            <div class="row" style="padding-bottom: 20px">
                <div class="col-lg-2 col-md-2 cofl-sm-2 name_info">
                    <p>Solicitante:</p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                    {{ info_rut.nombre }} {{ info_rut.apellido_p}} {{ info_rut.apellido_m}}
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info">
                    <p>Celular:</p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                    {{ info_rut.celular }}
                </div>
                <hr class="col-lg-10 col-md-10 col-sm-10" />
            </div>
            <div class="row" style="padding-bottom: 20px">
                <div class="col-lg-2 col-md-2 col-sm-2 name_info">
                    <p>Calle:</p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                    {{ info_rut.calle }}
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info">
                    <p>Número:</p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                    {{ info_rut.numero }}
                </div>
                <hr class="col-lg-10 col-md-10 col-sm-10" />
            </div>
            <div class="row" style="padding-bottom: 20px">
                <div class="col-lg-2 col-md-2 col-sm-2 name_info">
                    <p>Comuna:</p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                    {{ info_rut.comuna }}
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info">
                    <p>Complemento:</p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                    {{ info_rut.complemento }}
                </div>
                <hr class="col-lg-10 col-md-10 col-sm-10" />
            </div>
            <div class="row" style="padding-bottom: 20px">
                <div class="col-lg-2 col-md-2 col-sm-2 name_info">
                    <p>Email:</p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                    {{ info_rut.email }}
                </div>

                <hr class="col-lg-10 col-md-10 col-sm-10" />
            </div>
        </div>
        <div *ngIf="!continuar" class="col-md-12 col-sm-12 col-lg-12 col-xs-12 error-mail">
            <p>El mail es obligatorio, favor modificar su usuario e ingresar un mail válido.</p>
        </div>
    </div>
    <div formGroupName="mod_solicitante" class="container_info_rut" *ngIf="modificando">
        <div class="row title_mod_div" *ngIf="rut_encontrado">
            <strong>
                <p class="title_mod">Modificando Datos del solicitante</p>
            </strong>
        </div>
        <div class="row title_mod_div" *ngIf="!rut_encontrado">
            <strong>
                <p class="title_mod">Registrando Datos del solicitante</p>
            </strong>
        </div>
        <div class="row" style="margin-left: 10%;">
            <div class="col-lg-6 col-md-6 col-sm-6">
                <p class="title_info">Nombre *</p>
                <mat-form-field>
                    <input matInput formControlName="nombre">
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
                <p class="title_info">Apellido Paterno</p>
                <mat-form-field>
                    <input matInput formControlName="apellido_p">
                </mat-form-field>
            </div>

        </div>
        <div class="row" style="margin-left: 10%;">
            <div class="col-lg-6 col-md-6 col-sm-6">
                <p class="title_info">Apellido Materno</p>
                <mat-form-field>
                    <input matInput formControlName="apellido_m">
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
                <p class="title_info">Celular *</p>
                <mat-form-field>
                    <input matInput formControlName="cel">
                </mat-form-field>
            </div>
        </div>
        <div class="row" style="margin-left: 10%;">
            <div class="col-lg-6 col-md-6 col-sm-6">
                <p class="title_info">Teléfono </p>
                <mat-form-field>
                    <input matInput formControlName="telefono">
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
                <p class="title_info">Email *</p>
                <mat-form-field>
                    <input matInput formControlName="email">
                </mat-form-field>
            </div>
            <!--  <div class="col-lg-6 col-md-6 col-sm-6">
            <p class="title_info">Ciudad</p>
            <mat-form-field>
                <input matInput formControlName="ciudad">
            </mat-form-field>
        </div> -->
        </div>
        <div class="row" style="margin-left: 10%;">
            <div class="col-lg-6 col-md-6 col-sm-6">
                <p class="title_info">Comuna</p>
                <mat-form-field>
                    <input matInput formControlName="comuna">
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
                <p class="title_info">Calle *</p>
                <mat-form-field>
                    <input matInput formControlName="calle">
                </mat-form-field>
            </div>

        </div>
        <div class="row" style="margin-left: 10%;">
            <div class="col-lg-6 col-md-6 col-sm-6">
                <p class="title_info">Número *</p>
                <mat-form-field>
                    <input matInput formControlName="num" required>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
                <p class="title_info">Complemento</p>
                <mat-form-field>
                    <input matInput formControlName="complemento">
                </mat-form-field>
            </div>
        </div>
        <!--  <div class="row" style="margin-left: 10%;">
     
    </div> -->

    </div>
    <div *ngIf="!modificando" class="row" style="padding: 0px">
        <div class="col-lg-6 col-md-6 col-sm-6">
            <button mat-raised-button color="primary" (click)="mod_inforut()"
                [disabled]="!rut_encontrado">Modificar</button>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6" align="right">
            <button mat-raised-button color="primary" (click)="parametros()" mat-button
                [disabled]="!primerPaso || !continuar || !emailValido" matStepperNext>Continuar</button>
        </div>
    </div>
    <div *ngIf="modificando" class="col-md-12" style="padding: 0px">
        <div class="col-lg-6 col-md-6 col-sm-6" align="left" style="padding: 0px">
            <button class="btn_danger" mat-raised-button (click)="cancelar_mod()">Cancelar</button>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6" *ngIf="rut_encontrado" align="right" style="padding: 0px">
            <button mat-raised-button color="primary"
                [disabled]="firstFormGroup.controls.mod_solicitante.controls.cel.value===''||firstFormGroup.controls.mod_solicitante.controls.calle.value===''||firstFormGroup.controls.mod_solicitante.controls.nombre.value===''||firstFormGroup.controls.mod_solicitante.controls.email.value===''"
                (click)="guarda_mod()">Guardar</button>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6" *ngIf="!rut_encontrado" align="right" style="padding: 0px">
            <button mat-raised-button color="primary" (click)="registro_sol()"
                [disabled]="firstFormGroup.controls.mod_solicitante.controls.cel.value===''||firstFormGroup.controls.mod_solicitante.controls.calle.value===''||firstFormGroup.controls.mod_solicitante.controls.nombre.value===''||firstFormGroup.controls.mod_solicitante.controls.email.value===''">Registrar</button>
        </div>
    </div>



</form>